<template>
  <GlideTranslation :callback="update">
    <div class="contact__brand-moment">
      <!-- This is to maintain spacing -->
      <div class="contact__brand-moment--dummy start-working__fill-container">
        <span
          aria-hidden="true"
          class="start-working start-working__fill">Start</span>
        <span
          aria-hidden="true"
          class="start-working start-working__fill">Working</span>
      </div>
      <!-- Begin Fills (aria hidden) -->

      <!-- Working Fill -->
      <div
        :style="{ opacity: opacity }"
        class="contact__brand-moment--child start-working__fill-container"
      >
        <span
          aria-hidden="true"
          class="start-working start-working__fill">Start</span>
        <span
          aria-hidden="true"
          class="start-working start-working__fill">Working</span>
      </div>

      <!-- Dreaming Fill -->
      <div
        :style="{ opacity: 1 - opacity }"
        class="contact__brand-moment--child stop-dreaming__fill-container"
      >
        <div>
          <span
            aria-hidden="true"
            class="stop-dreaming stop-dreaming__stop stop-dreaming__fill">Stop</span>
          <span
            aria-hidden="true"
            class="stop-dreaming stop-dreaming__dreaming stop-dreaming__fill">Dreaming</span>
        </div>
      </div>

      <!-- Begin Strokes (aria visible) -->

      <!-- Working Stroke -->
      <div
        class="contact__brand-moment--child start-working__stroke-container"
      >
        <span class="start-working start-working__stroke">Start</span>
        <span class="start-working start-working__stroke">Working</span>
      </div>

      <!-- Dreaming Stroke -->
      <div
        class="contact__brand-moment--child stop-dreaming__stroke-container"
      >
        <div>
          <span class="stop-dreaming stop-dreaming__stop stop-dreaming__stroke">Stop</span>
          <span class="stop-dreaming stop-dreaming__dreaming stop-dreaming__stroke">Dreaming</span>
        </div>
      </div>
    </div>
  </GlideTranslation>
</template>

<script>
  export default {
    data() {
      return {
        opacity: undefined,
      };
    },
    methods: {
      update({ y }) {
        const { min, max } = Math;

        this.opacity = max(min(0.5, y), 0) / 0.5;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .contact__brand-moment {
    position: relative;
    padding-top: spacing(base-zeta);
    padding-bottom: spacing(base-zeta);
    background-color: color(bronze);
    overflow: hidden;
  }

  .contact__brand-moment--child {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .start-working__stroke {
    color: color(bronze);
    text-shadow:
     -1px -1px 0 color(white),
     1px -1px 0 color(white),
     -1px 1px 0 color(white),
     1px 1px 0 color(white);
  }

  .start-working__fill {
    color: color(white);
    text-shadow:
     -1px -1px 0 color(white),
     1px -1px 0 color(white),
     -1px 1px 0 color(white),
     1px 1px 0 color(white);
  }

  .stop-dreaming__stroke {
    color: color(bronze);
    text-shadow:
     -1px -1px 0 color(slate),
     1px -1px 0 color(slate),
     -1px 1px 0 color(slate),
     1px 1px 0 color(slate);
  }

  .stop-dreaming__fill {
    color: color(slate);
    text-shadow:
     -1px -1px 0 color(slate),
     1px -1px 0 color(slate),
     -1px 1px 0 color(slate),
     1px 1px 0 color(slate);
  }

  .stop-dreaming,
  .start-working {
    font-family: font-family(san-serif);
    font-weight: font-weight(extra-bold);
    display: inline-block;
    text-transform: uppercase;
  }

  .stop-dreaming__dreaming {
    display: block;
    margin-left: 20px;

    @include breakpoint(phablet) {
      margin-left: 45px;
    }
  }

  .stop-dreaming {
    font-size: 2.5rem;

    @include breakpoint(phablet) {
      font-size: 5.5rem;
    }
  }

  .start-working {
    font-size: 8.2rem;

    @include breakpoint(phablet) {
      font-size: 20.2rem;
    }
  }

  .start-working__container {
    text-align: center;
  }

  .contact__brand-moment--dummy {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    visibility: hidden;
  }

  .start-working__fill-container {
    z-index: 4;
  }

  .stop-dreaming__fill-container {
    z-index: 3;
  }

  .stop-dreaming__stroke-container {
    z-index: 2;
  }

  .start-working__stroke-container {
    z-index: 1;
  }
</style>
